export var screens = {
    'can-hover': {
        raw: '(hover)'
    },
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px'
};

//# sourceMappingURL=screens.js.map